import { createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"
import _imports_0 from '@/assets/calendar-todo-fill.png'


const _hoisted_1 = /*#__PURE__*/_createElementVNode("img", {
  class: "input-slot-image",
  src: _imports_0
}, null, -1)

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_DatePicker = _resolveComponent("DatePicker")!

  return (_openBlock(), _createElementBlock("div", null, [
    _createVNode(_component_DatePicker, {
      modelValue: $setup.dates,
      "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => (($setup.dates) = $event)),
      "format-locale": $setup.ko,
      "select-text": "확인",
      "cancel-text": "취소",
      "enable-time-picker": false,
      range: "",
      "multi-calendars": "",
      clearable: false,
      format: $setup.dateFormat,
      class: "select_date",
      "auto-apply": true
    }, {
      "input-icon": _withCtx(() => [
        _hoisted_1
      ]),
      _: 1
    }, 8, ["modelValue", "format-locale", "format"])
  ]))
}